import {Select} from "antd";

/**
 * Đánh dấu xử lý issue (biến báo cáo thành danh sách việc).
 *
 * - issueRef(issue): định danh ỔN ĐỊNH của issue qua các lần crawl — URL trang (issue
 *   theo trang), URL target (link hỏng), canonical/URL đầu nhóm (duplicate). Cùng logic
 *   với khoá (type, ref) lưu ở bảng issue_marks.
 * - markKey(type, ref): khoá tra cứu trong map marks phía FE.
 * - IssueMarkSelect: ô chọn trạng thái nhỏ gọn đặt cạnh từng issue.
 */
export const issueRef = (issue) =>
	issue?.url
	|| issue?.meta?.target
	|| issue?.meta?.canonical
	|| (Array.isArray(issue?.meta?.urls) ? issue.meta.urls[0] : '')
	|| '';

export const markKey = (type, ref) => `${type}||${ref}`;

export const MARK_META = {
	in_progress: {label: 'Đang xử lý', color: '#2563eb'},
	resolved: {label: 'Đã sửa', color: '#16a34a'},
	ignored: {label: 'Bỏ qua', color: '#6b7280'},
};

const OPTIONS = [
	{value: 'none', label: 'Chưa xử lý'},
	{value: 'in_progress', label: 'Đang xử lý'},
	{value: 'resolved', label: 'Đã sửa'},
	{value: 'ignored', label: 'Bỏ qua'},
];

/** Ô chọn trạng thái xử lý của 1 issue. status: null | in_progress | resolved | ignored. */
export function IssueMarkSelect({status, onChange}) {
	const value = status || 'none';
	const color = MARK_META[value]?.color;

	return (
		<Select
			size="small"
			value={value}
			options={OPTIONS}
			onChange={onChange}
			style={{width: 122, ...(color ? {color} : {})}}
			// Không cho click lan ra hàng issue (hàng có onClick mở trang).
			onClick={(e) => e.stopPropagation()}
		/>
	);
}
